import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function AdsBlockerBait() {
  const ref = useRef<HTMLImageElement>(null);

  const { pathname, state } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    const bait = ref?.current;

    if (!bait) return;

    const observer = new ResizeObserver(() => {
      if (ref?.current?.clientHeight === 0) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('ab', 'true');
        navigate({ pathname, search: searchParams.toString() }, { replace: true, state });
      }
    });

    observer.observe(bait);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <img
      ref={ref}
      src='https://tpc.googlesyndication.com/simgad'
      width='1'
      height='1'
      alt=''
      className='img_ad'
    />
  );
}
